import axios from "@/axios.js";
import { db } from "@/firebase";
import { doc, collection, onSnapshot } from "firebase/firestore";
import { sortProductCategories } from "@/utils/productCategoryOrder";

export default {
    namespaced: true,

    state: () => ({
        pageInfo: null,
        unsubscribe: null,
        isPageLoading: true

    }),

    getters: {
        getPageInfo: (state) => state.pageInfo,
    },

    mutations: {
        SET_PAGE(state, payload) {
            state.pageInfo = payload;
        },
        SET_UNSUB(state, fn) {
            state.unsubscribe = fn;
        },
        SET_PAGE_LOADING(state, val) {
            state.isPageLoading = val;
        }
    },

    actions: {
        async loadPageInfo({ commit }, pageId) {
            try {
                const res1 = await axios.post(
                    `${process.env.VUE_APP_BACKEND_URL}/api/pages/`,
                    { id: pageId }
                );
                const res2 = await axios.post(
                    `${process.env.VUE_APP_BACKEND_URL}/api/autoPost/`,
                    { id: pageId }
                );

                commit("SET_PAGE", {
                    ...res1.data,
                    autoPost: res2.data.data
                });

                console.log("SET_PAGE", {
                    ...res1.data,
                    autoPost: res2.data.data
                })

                return { error: false };

            } catch (err) {
                console.error("loadPageInfo:", err.response?.data || err);
                commit("SET_PAGE", null);
                return { error: true };
            }
        },


        listenPageInfoRealtime({ commit, state }, pageId) {

            if (!pageId) return
            if (state.unsubscribe) state.unsubscribe();

            const pageRef = doc(db, "pages", pageId);
            const businessRef = doc(db, "pages", pageId, "settings", "business");
            const chatRef = doc(db, "pages", pageId, "settings", "chat");
            const commentRef = doc(db, "pages", pageId, "settings", "comment");
            const contentRef = doc(db, "pages", pageId, "settings", "content");
            // ✅ ใหม่ — แก้บั๊ก: เดิมไม่มี listener ของ settings/payment, settings/stripe, settings/shipping
            // เลย ทั้งที่ /api/pages (loadPageInfo ด้านบน) ดึงมาให้ครบทุก settings doc อยู่แล้ว พอ
            // listenPageInfoRealtime ยิง snapshot แรกมา (เร็วมาก) จะ overwrite state ที่ loadPageInfo
            // เพิ่งดึงมาครบๆ ด้วยเวอร์ชันที่ไม่มี payment/stripe/shipping เลย ทำให้ pageInfo.settings.payment
            // เป็น undefined ตลอด session แม้ร้านจะตั้งค่าช่องทางชำระเงินไว้แล้วจริงก็ตาม (บั๊กนี้ทำให้
            // AiTestChatModal.vue คิดว่าร้านไม่มีช่องทางชำระเงินเลย เลย auto-trigger โหมดปิดการขายไม่ได้)
            const paymentRef = doc(db, "pages", pageId, "settings", "payment");
            const stripeRef = doc(db, "pages", pageId, "settings", "stripe");
            const shippingRef = doc(db, "pages", pageId, "settings", "shipping");
            // ⚠️ แก้บั๊ก — เดิมไม่มี listener ของ settings/instagram เลย (เหตุผลเดียวกับ payment/stripe/
            // shipping ด้านบน) ทำให้ pageInfo.settings.instagram หายไปตลอด session แม้ facebook.js
            // (/auth) จะ sync สถานะเชื่อมต่อ IG เข้า Firestore สำเร็จจริงก็ตาม — /api/pages (loadPageInfo)
            // ดึงมาได้ถูกต้องตอน initial load เพราะมันวน settingsSnap ทุก doc แบบ generic แต่พอ
            // listenPageInfoRealtime ยิง snapshot แรกของ doc อื่นๆ มา (เช่น chat/comment) updateState()
            // จะ rebuild settings object ใหม่ทั้งก้อนโดยไม่มี key "instagram" เลย เท่ากับทับค่าที่เคยมี
            // จาก initial load ทิ้งไปเงียบๆ — หน้าตั้งค่าเพจ/ManagerChatScreen/ManagerCommentScreen เลย
            // เห็น settings.instagram เป็น undefined ตลอด ทั้งที่ Firestore มีข้อมูล connected: true จริง
            const instagramRef = doc(db, "pages", pageId, "settings", "instagram");
            const eventsRef = collection(db, "pages", pageId, "events");
            const productsRef = collection(db, "pages", pageId, "products");
            const adsRef = collection(db, "pages", pageId, "ads");
            // 🚨 แก้บั๊ก — เดิมไม่มี listener ของ productCategories เลย (เหตุผลเดียวกับ payment/stripe/
            // shipping/instagram ด้านบน) updateState() ด้านล่างเป็นการ rebuild pageInfo object ใหม่ทั้ง
            // ก้อนทุกครั้งที่ listener ไหนก็ตามยิง snapshot มา ไม่ใช่แค่ merge ทับ field เดียว — ถ้า
            // productCategories ไม่ได้ถูก include ไว้ใน object ที่ rebuild ตรงนั้นเลย ก็จะหายไปเป็น
            // undefined ทันทีที่ listener แรกๆ (เช่น settings/business) fire ทับ pageInfo ที่ /api/pages
            // (loadPageInfo ด้านบน) เพิ่งดึงมาครบๆ ตั้งแต่ตอนโหลดหน้าแรก — ตรงกับอาการที่เจอ: log ตอน
            // โหลดหน้าเห็น productCategories ครบ แต่พอ modal เปิดขึ้นมาที่หลัง (หลัง listener อื่น
            // ทันมา fire แล้ว) กลับว่างเปล่า
            const productCategoriesRef = collection(db, "pages", pageId, "productCategories");


            const autoPostRef = doc(db, "autoPost", pageId);


            let pageData = null;
            let businessData = null;
            let chatData = null;
            let commentData = null;
            let contentData = null;
            let paymentData = null;
            let stripeData = null;
            let shippingData = null;
            let instagramData = null;
            let eventsData = [];
            let productsData = []
            let adsData = []
            let productCategoriesData = [] // ✅ ใหม่
            let autoPostData = null

            const updateState = () => {
                commit("SET_PAGE", {
                    page: pageData || {},
                    events: Array.isArray(eventsData) ? eventsData : [],
                    products: Array.isArray(productsData) ? productsData : [],
                    ads: Array.isArray(adsData) ? adsData : [],
                    productCategories: Array.isArray(productCategoriesData) ? productCategoriesData : [], // ✅ ใหม่
                    settings: {
                        ...(pageData?.settings ?? {}),
                        business: businessData || {},
                        chat: chatData || {},
                        comment: commentData || {},
                        content: contentData || {},
                        payment: paymentData || {},
                        stripe: stripeData || {},
                        shipping: shippingData || {},
                        instagram: instagramData || {},
                    },
                    autoPost: autoPostData || {}
                });
            };

            const unsubPage = onSnapshot(pageRef, (snap) => {
                if (!snap.exists()) {
                    commit("SET_PAGE", null);
                    return;
                }
                pageData = snap.data();
                updateState();
            });

            const unsubBusiness = onSnapshot(businessRef, (snap) => {
                businessData = snap.exists() ? snap.data() : {};
                updateState();
            });

            const unsubChat = onSnapshot(chatRef, (snap) => {
                chatData = snap.exists() ? snap.data() : {};
                updateState();
            });

            const unsubComment = onSnapshot(commentRef, (snap) => {
                commentData = snap.exists() ? snap.data() : {};
                updateState();
            });
            const unsubContent = onSnapshot(contentRef, (snap) => {
                contentData = snap.exists() ? snap.data() : {};
                updateState();
            });

            // ✅ ใหม่ — listener ที่ขาดไป (ดู comment ด้านบนตรง paymentRef/stripeRef/shippingRef)
            const unsubPayment = onSnapshot(paymentRef, (snap) => {
                paymentData = snap.exists() ? snap.data() : {};
                updateState();
            });

            const unsubStripe = onSnapshot(stripeRef, (snap) => {
                stripeData = snap.exists() ? snap.data() : {};
                updateState();
            });

            const unsubShipping = onSnapshot(shippingRef, (snap) => {
                shippingData = snap.exists() ? snap.data() : {};
                updateState();
            });

            const unsubInstagram = onSnapshot(instagramRef, (snap) => {
                instagramData = snap.exists() ? snap.data() : {};
                updateState();
            });

            const unsubEvents = onSnapshot(eventsRef, (snap) => {
                eventsData = snap.docs.map(d => ({
                    id: d.id,
                    ...d.data()
                }));

                updateState();
            });

            const unsubProducts = onSnapshot(productsRef, (snap) => {
                productsData = snap.docs.map(d => ({
                    id: d.id,
                    ...d.data()
                }));

                updateState();
            });


            const unsubAds = onSnapshot(adsRef, (snap) => {
                adsData = snap.docs.map(d => ({
                    id: d.id,
                    ...d.data()
                }));

                updateState();
            });

            // ✅ ใหม่ — listener ที่ขาดไป (ดู comment ยาวๆ ตรง productCategoriesRef ด้านบน)
            const unsubProductCategories = onSnapshot(productCategoriesRef, (snap) => {
                // ✅ แก้ไข — เรียงตามลำดับที่ร้านตั้ง (order) ทุกที่ที่ใช้ pageInfo.productCategories จะได้ลำดับ
                // เดียวกับหน้าร้าน (onSnapshot ไม่ได้เรียงให้ — เดิมลำดับเปลี่ยนไปมาตาม id ของเอกสาร)
                productCategoriesData = sortProductCategories(snap.docs.map(d => ({
                    id: d.id,
                    ...d.data()
                })));

                updateState();
            });

            const unsubAutoPost = onSnapshot(autoPostRef, (snap) => {
                autoPostData = snap.exists() ? snap.data() : {};
                updateState();
            });


            commit("SET_UNSUB", () => {
                unsubPage();
                unsubBusiness();
                unsubEvents();
                unsubChat();
                unsubComment();
                unsubContent();
                unsubProducts();
                unsubProductCategories();
                unsubAutoPost();
                unsubAds();
                unsubPayment();
                unsubStripe();
                unsubShipping();
                unsubInstagram();
            });
        },

        // ✔ ย้ายมาอยู่ใน actions
        removePageInfo({ commit, state }) {
            if (state.unsubscribe) state.unsubscribe();

            commit("SET_PAGE", null);
            commit("SET_UNSUB", null);
        }
    },
};